module.exports = __webpack_public_path__ + "static/media/Hugfimi-hollow-side.d41d8cd9.webp";